export default {
      id: "circle__turn-usage",
      viewBox: "0 0 28 27",
      url: __webpack_public_path__ + "img/icons.svg#circle__turn",
      toString: function () {
        return this.url;
      }
    }